<template>
  <div>
    <div v-if="data && data.length">
      <div class="row" style="border: 1px solid #e0e0e0">
        <div class="d-flex col-12 justify-content-between px-3 py-2" style="background-color: #f8f8fb;">
          <div><h5 class="text-list-rokomo-7 mb-1">履歴照会</h5></div>
        </div>
        <div class="p-0">
          <Spliter :initialLeftWidth="250">
            <template #left>
              <div class="col-12 px-1">
                <div class="mt-2 px-1">
                  <b-button class="w-lg btn-edit" :disabled="selectedIndexes.length === 0" :class="{'bg-disabled': selectedIndexes.length === 0}" @click="exportExcel()">Excel出力</b-button>
                </div>
                <div class="table-responsive mt-2 mb-0 scroll" :style="{minHeight: isExpand ? '67vh': '50vh'}">
                  <vue-loadmore :on-loadmore="onLoad" loading-text="読み込み中" :finished="finished" finished-text=" ">
                    <table class="table align-middle mb-0" id="table">
                      <tbody>
                      <tr id="tr" v-for="(history, index) in data" :key="index" @click="showDetail(index), (activeIndex = index)" style="cursor: pointer" >
                        <td class="text-center pe-1" :class="{ 'bg-active-rokomo': index === activeIndex }">
                          <input class="form-check-input" type="checkbox" @click="toggleCheck(index)" id="formCheckRight2" :checked="isChecked(index)" style="font-size: 24px; margin: 0;"/>
                        </td>
                        <td width="100%" class="px-1":class="{ 'bg-active-rokomo': index === activeIndex }">
                          <h5 class="text-list-rokomo-7 mb-0">
                            {{ history.tested_date | fomatDate2 }}
                          </h5>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </vue-loadmore>
                </div>
              </div>
            </template>

            <template #right>
              <div class="col-12 px-3 pt-3 position-relative" style="font-size: 16px; ">
                <div class="mb-4">
                  <div class="clearfix fs-4">
                    <div class="float-start">
                      <span>メニュー：</span>
                      <strong>{{ suggestionTitle }}</strong>
                    </div>
                  </div>
                  <div v-if="items.length" class="col-12 mt-3">
                    <table class="table custome-table">
                      <thead>
                        <tr>
                          <th class="col">動画名</th>
                          <th class="col">実施回数</th>
                          <th class="col">痛みの有無</th>
                          <th class="col">実施時間</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="item in items" :key="item.id" >
                          <td>{{ item.rehab_video?.name }}</td>
                          <td>{{ item.count }}</td>
                          <td>{{ item.pain_title }}</td>
                          <td>{{  formatTime(item.tested_at) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
          </Spliter>
        </div>
      </div>
    </div>

    <div v-else class="undefine">
      <img src="@/assets/images/no-data.jpg" alt="" />
      <div class="mt-3">詳細データはありません。</div>
    </div>
  </div>
</template>

<script>
import {filter} from "@/helpers/Vue-Filter";
import moment from 'moment';
import {orderBy} from 'lodash';
import api from "@/api";
import Spliter from "./spliter.vue";

export default {
  filters: {
    ...filter,
  },
  components: {Spliter},
  props: ["data", "pagination", "userInfor", "isExpand"],
  data() {
    return {
      activeIndex: 0,
      selectedIndexes: [],
      finished: false,
      page: 1,
      items: [],
      listIds: [],
      testedDate: null,
      suggestionTitle: null,
    };
  },

  mounted() {
    if (this.data.length) {
      this.showDetail(0);
    }
  },

  methods: {
    showDetail(index) {
      const term = this.data[index];
      this.items = orderBy(term.data, ['id'], ['desc']);
      this.testedDate = term.tested_date;
      this.suggestionTitle = term.rehab_video_suggestion_title;
    },

    formatTime(datetime) {
      return moment(new Date(datetime)).format('HH時mm分')
    },

    toggleCheck(index) {
      this.listIds = [];
      const selectIndex = this.selectedIndexes.indexOf(index);
      if (selectIndex !== -1) {
        this.selectedIndexes.splice(selectIndex, 1);
      } else {
        this.selectedIndexes.push(index);
      }

      this.selectedIndexes.map((item) => {
        this.data[item].data.map((i) => this.listIds.push(i.id));
      })
    },

    isChecked(id) {
      if (this.selectedIndexes.includes(id)) return true;
      return false;
    },

    isCheckedAll() {
      return this.data.length === this.selectedIndexes.length;
    },

    exportPDF() {
      if (this.selectedIndexes.length) {
        this.$emit("clickExport", this.selectedIndexes);
      }
    },

    exportExcel() {
      const payload = {};
      payload.ids = this.listIds.toString();
      console.log(payload);
      try {
        const formattedDate = moment().format('YYYYMMDD');
        api.exportHistory('rehab', payload, `リハビリ履歴_${this.userInfor.mobile}_${this.userInfor.patient_id}_${formattedDate}`);
      } catch (error) {
        console.log(error);
      }
    },

    onLoad(done) {
      if (this.page <= this.pagination.last_page) {
        this.loadMore();
      } else {
        // all data loaded
        this.finished = true;
      }
      done();
    },

    loadMore() {
      this.$emit("loadMore", this.selectedIndexes);
      this.page++;
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  font-family: "Noto Sans JP";
}
.text-list-rokomo-7 {
  color: #404040;
  font-size: 16px;
  font-weight: 700;
}

.text-list-time {
  color: #404040;
  font-weight: 400;
  font-size: 14px;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

::-webkit-input-placeholder {
  color: #d3d3d3 !important;
  opacity: 1; /* Firefox */
}

.bg-active-rokomo {
  background: #b8e060;
}

.text-end {
  align-items: end;
}

.scroll {
  // max-height: 50vh;
  overflow-y: scroll;
}

/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.undefine {
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #404040;
}

.select-all {
  overflow-y: scroll;
}

.text-right {
  text-align: right;
}


.custome-table tbody tr {
  height: 20px !important;
}

.btn-edit {
  color: white;
  background-color: #8fc31f;
  border: none;
  border-radius: 4px;
  padding: 5px;
  font-size: 14px;
  margin-left: 24px;
}
.bg-disabled {
  background: #ffffff !important;
  color: #d3d3d3 !important;
}
</style>
